import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core'
import { Subscription } from 'rxjs'
import { ActivationStatus } from 'src/app/shared/enums/general.enum'
import { CategoryList } from '../../models/category.model'
import { FlatTreeControl } from '@angular/cdk/tree'
import { MatTreeFlatDataSource, MatTreeFlattener } from '@angular/material/tree'
import { AddEditBrandComponent } from '../add-edit-brand/add-edit-brand.component'
import { MatDialog } from '@angular/material/dialog'
import { TranslateService } from '@ngx-translate/core'
import { ConfirmationMessageComponent } from 'src/app/shared/components/confirmation-message/confirmation-message'
import { StoreService } from '../../services/store.service'
import { environment } from 'src/environments/environment'

@Component({
	selector: 'app-categories-table',
	templateUrl: './categories-table.component.html',
	styleUrls: ['./categories-table.component.scss'],
})
export class CategoriesTableComponent implements OnInit {
	displayedColumns: string[] = ['NameEN', 'NameAr', 'count', 'activation', 'a']
	@Input() categories!: CategoryList[]
	@Input() dataSource!: any
	@Input() categoryFilter: any = {
		paging: { pageNumber: 1, pageSize: 10 },
		searchText: '',
	}
	@Input() totalCount = 0
	subscription = new Subscription()
	statusEnum = ActivationStatus
	@Output() activationState = new EventEmitter()
	attachmentUrl = environment.attachmentPath

	// private _transformer = (cat: CategoryList, level: number) => {
	// 	return {
	// 		expandable: !!cat.subCategories && cat.subCategories.length > 0,
	// 		name: {
	// 			ar:cat.name?.ar,
	// 			en:cat.name?.en,
	// 		   },
	// 		products: cat.products,
	// 		isActive: cat.isActive,
	// 		level,
	// 		id: cat.id,
	// 		imageUrl: cat.imageUrl,
	// 		canDelete: cat.canDelete,
	// 		subCategories: cat.subCategories,
	// 		parentId: cat.parentId,
	// 	}
	// }
	// types: any = []

	treeControl = new FlatTreeControl<any>(
		(cat) => cat.level,
		(cat) => cat.expandable
	)

	// treeFlattener = new MatTreeFlattener(
	// 	this._transformer,
	// 	(cat) => cat.level,
	// 	(cat) => cat.expandable,
	// 	(cat) => cat.subCategories
	// )

	// dataSource = new MatTreeFlatDataSource(this.treeControl, this.treeFlattener)
	constructor(private dialog: MatDialog, public translate: TranslateService, private categoryService:StoreService) {
	
		
	}
	hasChild = (_: number, cat: any) => cat.expandable
	ngOnInit(): void {
		// this.dataSource.data = this.categories
	}

	addEditSubCategory(parentCategory: CategoryList,type?: string) {
		this.dialog
			.open(AddEditBrandComponent, {
				width: '585px',
				data: {
					type: type,
					title:
						type == 'add'
							? 'ACTIONS.ADD_SUBCATEGORY'
							: 'ACTIONS.EDIT_SUBCATEGORY',
					label: 'STORE.CATEGORY_LIST.SUB_ENGLISH_NAME',
					label2: 'STORE.CATEGORY_LIST.SUB_ARABIC_NAME',
					confirmBtn: type == 'add' ? 'ACTIONS.ADD' : 'ACTIONS.EDIT',
				},
				autoFocus: false,
			})
			.afterClosed()
			.subscribe({
				next: (res) => {
					if (res) {
						if (res) {
							let data = {
								nameEn: res.f1,
								nameAr: res.f2,
								img: res.f3,
							}

						}
					}
				},
			})
	}

	deleteCategory(categoryData: any) {
		this.dialog
			.open(ConfirmationMessageComponent, {
				width: '416',
				height: '360',

				data: {
					message: 'CONFIRMATION_MESSAGE.DELETE_CONFIRMATION',

					title: this.translate.instant('ACTIONS.DELETE', {
						name: categoryData?.name,
					}),
					notflex: true,
					cancelBtn: 'ACTIONS.NO',
					confirmBtn: 'ACTIONS.DELETE',
				},
			})
			.afterClosed()
			.subscribe({
				next: (res) => {
					if (res) {
						this.subscription.add()
					}
				},
			})
	}

	ngOnDestroy(): void {
		this.subscription.unsubscribe()
	}
}
